import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSpring, animated, config } from "@react-spring/web";

const Button = ({ textId = "button", onClick = () => {}, ...props }) => {
  const { t } = useTranslation();

  const [hovered, setHovered] = useState(false);

  const { backgroundColor } = useSpring({
    backgroundColor: hovered ? "#5cd89a" : "#37a46e",
    config: config.stiff,
  });

  return (
    <animated.div
      onClick={(e) => {
        onClick(e);
      }}
      style={{
        color: "#000",
        textAlign: "center",
        width: "max-content",
        fontSize: "0.9vw",
        fontWeight: 500,
        padding: "0.75vw",
        paddingLeft: "0.75vw",
        paddingTop: "0.5vw",
        paddingBottom: "0.5vw",
        pointerEvents: "auto",
        transition: "boxShadow 0.9s linear",
        borderRadius: "3px",
        cursor: "pointer",
        opacity: 1,
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        minWidth: "5vw",
        display: "flex",
        justifyContent: "center",
        marginRight: "1.5vw",
      }}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      {t(textId)}
    </animated.div>
  );
};

export default Button;
